import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { OsusumeService } from '../../services/osusume.service';
import { OsusumeCategoryList } from '../../models/plan/osusume';
import { Subject } from 'rxjs';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-osusume-edit',
  templateUrl: './osusume-edit.component.html',
  styleUrls: ['../osusume-setting/osusume-setting.component.css']
})
export class OsusumeEditComponent implements OnInit, OnDestroy {
  public kyotenCd: string;
  public listCategory = [];
  public isLoading = true;
  public isNodata = false;
  public categoryNo = 1;
  public categoryName: string;
  public showCategoryDialog = false;
  ngUnsubscribe = new Subject();
  @Output('close') close: any = new EventEmitter();
  constructor(private osusumeSv: OsusumeService, private _data: DataService) {}

  ngOnInit() {
    this.kyotenCd = this._data.kyotenCd;
    if (this.osusumeSv.listCategory && this.kyotenCd === this.osusumeSv.kyotenCd) {
      this.isLoading = false;
      this.listCategory = this.osusumeSv.listCategory;
    } else {
      this.getCategory();
    }

    this.osusumeSv.loadCategory
      .takeUntil(this.ngUnsubscribe)
      .subscribe(isLoad => {
        if (isLoad) {
          this.getCategory();
        }
      });
  }

  getCategory() {
    this.osusumeSv
      .getCategory(this.kyotenCd)
      .subscribe((data: OsusumeCategoryList) => {
        if (data) {
          this.listCategory = this.osusumeSv.setCategoryArray(data);
          this.osusumeSv.listCategory = this.listCategory;
        }
        this.isLoading = false;
      });
  }

  editCategory(index, categoryName) {
    this.categoryNo = index + 1;
    this.categoryName = categoryName;
    this.showCategoryDialog = true;
  }

  removeCategory(index) {
    console.log(index);
    this.listCategory.splice(index, 1);
  }

  onCloseCategoryDialog() {
    this.showCategoryDialog = false;
    this.categoryNo = null;
    this.categoryName = null;
  }

  onClose() {
    this.close.emit();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/osusume/osusume-edit/osusume-edit.component.ts